import axios from 'axios'

const getDefaultState = () => {
    return {
        table: {
            rows: [],
            totalRecords: 0,
            serverParams: {
                // columnFilters: {},
                // sort: {
                //     field: '',
                //     type: '',
                // },
                // sortFormat: '',
                // filterFormat: '',
                // filterGlobal: '',
                sort: '',
                page: 1,
                perPage: 10
            }
        },
        paramsReturn: {
            page: '',
            perPage: '',
            sort: ''
        }
    }
}

// initial state
const state = getDefaultState()

const mutations = {
    'TABLE_RESET'(state) {
        Object.assign(state, getDefaultState())
    },
    'FETCH_ITEMS'(state, data) {
        state.table.rows = data.data
        state.table.totalRecords = data.meta.total
        state.table.serverParams.page = data.meta.current_page
        state.table.serverParams.perPage = data.meta.per_page
    },
    'CHANGE_SERVERPARAMS'(state, data) {
        if(data.perPage){
            state.table.serverParams.perPage = data.perPage
        }
        if(data.page){
            state.table.serverParams.page = data.page
        }

        //Sort goedzetten voor return naar API
        let sort = ''
        if(data.sort){
            let type = (data.sort[0].type == 'asc') ? '-' : ''
            let field = data.sort[0].field
            sort = type.toString() + field
        }
        state.table.serverParams.sort = sort

        //Filters toevoegen aan query voor API
        let filter = data.filter
        for (let key in filter) {
            state.table.serverParams['filter['+key+']'] = filter[key]
        }

        //Global filter toevoegen aan query voor API
        let filterGlobal = data.filterGlobal
        if(filterGlobal){
            state.table.serverParams['filter[search]'] = filterGlobal
        }else{
            state.table.serverParams['filter[search]'] = ''
        }
    }
}

const actions = {
    CHANGE_SERVERPARAMS: async (context, payload) => {
        context.commit('CHANGE_SERVERPARAMS', payload)
    },
    TO_DEFAULTSTATE: async (context, payload) => {
        context.commit('TABLE_RESET')
    },
}

const getters = {
    TABLE: state => {
        return state.table;
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}
